export const companyConfig = {
  name: 'REVO Manager',
  logo: 'https://storage.cloudqi.com.br/revo/Revo.png', 
  primaryColor: '#3b82f6',
  address: {
    street: 'Rua Exemplo, 123',
    city: 'São Paulo',
    state: 'SP',
    zip: '01310-100',
    phone: '(11) 3333-4444',
    email: 'contato@revo.com.br'
  },
  cnpj: '00.000.000/0001-00',
  website: 'www.revo.com.br',
  profile: {
    defaultProfilePhoto: '/default-profile.webp',
    defaultCoverPhoto: '/default-cover.jpg'
  }
};